// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"402":"07fd5f3a","550":"fd76212b"}[chunkId] + ".js";
};